import { create } from 'zustand';

import { 
    sendOccurrences,
    sendUpsertOccurrence,
    sendRemoveOccurrence 
} from '../channels/tripOccurrencesChannel';

export const useTripOccurrencesStore = create((set, get) => ({

    occurrences: {},

    setOccurrencesBatch: (occurrences = [], broadcast = true) => {

        const next = {};

        for (const occurrence of occurrences) {

            if (!occurrence?.tripUid) {
                continue;
            }

            if (!next[occurrence.tripUid]) {
                next[occurrence.tripUid] = [];
            }

            next[occurrence.tripUid].push(
                occurrence
            );
        }

        set({
            occurrences: next
        });

        if (broadcast) {
            sendOccurrences(occurrences);
        }
    },

    upsertOccurrence: (occurrence, broadcast = true) => {

        if (
            !occurrence?.tripUid ||
            !occurrence?.occurrenceUid
        ) {
            return;
        }

        const current =
            get().occurrences;

        const tripOccurrences =
            current[occurrence.tripUid] || [];

        const index =
            tripOccurrences.findIndex(
                item =>
                    item.occurrenceUid ===
                    occurrence.occurrenceUid
            );

        let nextTripOccurrences;

        if (index === -1) {

            nextTripOccurrences = [
                ...tripOccurrences,
                occurrence
            ];

        } else {

            nextTripOccurrences = [
                ...tripOccurrences
            ];

            nextTripOccurrences[index] =
                occurrence;
        }

        set({
            occurrences: {
                ...current,
                [occurrence.tripUid]:
                    nextTripOccurrences
            }
        });

        if (broadcast) {
            sendUpsertOccurrence(occurrence);
        }
    },

    removeOccurrence: (
        tripUid,
        occurrenceUid,
        broadcast = true
    ) => {

        const current =
            get().occurrences;

        const tripOccurrences =
            current[tripUid];

        if (!tripOccurrences) {
            return;
        }

        const nextTripOccurrences =
            tripOccurrences.filter(
                occurrence =>
                    occurrence.occurrenceUid !==
                    occurrenceUid
            );

        const next = {
            ...current
        };

        if (nextTripOccurrences.length) {

            next[tripUid] =
                nextTripOccurrences;

        } else {

            delete next[tripUid];
        }

        set({
            occurrences: next
        });

        if (broadcast) {
            sendRemoveOccurrence({
                tripUid,
                occurrenceUid
            });
        }
    },

    getTripOccurrences: (tripUid) => {

        return (
            get().occurrences[tripUid] ||
            []
        );
    },

    getLastTripOccurrence: (tripUid) => {

        if (!tripUid) {
            return null;
        }

        const occurrences =
            get().occurrences[tripUid] || [];

        if (!occurrences.length) {
            return null;
        }

        return occurrences.reduce(
            (latest, occurrence) => {

                if (!latest) {
                    return occurrence;
                }

                const currentDate =
                    new Date(
                        occurrence.createdAt
                    ).getTime();

                const latestDate =
                    new Date(
                        latest.createdAt
                    ).getTime();

                return currentDate > latestDate
                    ? occurrence
                    : latest;

            },
            null
        );

    },

    clearOccurrences: (
        broadcast = true
    ) => {

        set({
            occurrences: {}
        });

        if (broadcast) {
            sendOccurrences([]);
        }
    },

    sendOccurrencesSnapshot: () => {

        const occurrences =
                Object.values(
                    get().occurrences
                ).flat();

        sendOccurrences(occurrences);
    }

}));